export default __webpack_public_path__ + "static/media/smallCassette.d1e4bb8c.png";